import './ApplyFilterOptionButton.scss';

import type { ButtonProps } from '@components/Button';
import Button from '@components/Button';
import { createClsNameMap } from '@utils';

export type ApplyFilterOptionButtonProps = ButtonProps;
const clsNameMap = createClsNameMap({})('apply-filter-option-button');

export const ApplyFilterOptionButton = ({
  children,
  ...buttonProps
}: ApplyFilterOptionButtonProps) => {
  return (
    <Button className={clsNameMap.root()} {...buttonProps}>
      {children}
    </Button>
  );
};
